import { XYPlot, LineSeries, GradientDefs, AreaSeries } from 'react-vis';
import { numberWithCommas } from "./utils";
import {
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  useColorModeValue,
  IconButton,
  Box,
  useBreakpointValue
} from '@chakra-ui/react'
import { AiOutlineCamera } from 'react-icons/ai';
import { useEffect, useState } from "react";
import scrollIntoView from "scroll-into-view-if-needed";
import { color, textStyle } from 'theme/names';

export const StatsBox = ({
    title = "",
    data = [{}],
    labelValue = "0",
    percentageValue = 0,
    disableComparison = false,
    isLoading = true,
    mode="stats",
    boxStyleOverwrite={},
    labelStyleOverwrite={},
    onClickCallback = () => {},
    isClickable = false,
    canScreenshot = false,
    onScreenshot = () => {}
}: any) => {
    // console.log("stats-box data", data);
    const returnStatBox = (title && data && title!="" && data.length > 0)? true : false;
    const findNumSign = (num) => (num > 0)? "+" : "";
    const darkModeHeadingColor = useColorModeValue("gray.700","gray.300");
    const darkModeNumberColor = useColorModeValue("#494949","#939393");
    const darkModeClickableBg = useColorModeValue('#f6f6f6','#252525');
    const darkModeSnapshotColor = useColorModeValue('gray.400','gray.600');
    const darkModeSnapshotColorHover = useColorModeValue('#11BB8D','#93eed5');
    const [showBox, setShowBox] = useState<boolean>(false);
    const [boxPercentageValue, setBoxPercentageValue] = useState(percentageValue);
    const [boxLabelValue, setBoxLabelValue] = useState(labelValue);
    const [boxTitle, setBoxTitle] = useState(title);
    const [newData, setNewData] = useState(data);

    useEffect(()=>{
      setNewData([...data]);
      setBoxPercentageValue(percentageValue);
      setBoxLabelValue(labelValue);
      setBoxTitle(title);
      setShowBox(true);
    }, [data, percentageValue, title, labelValue]);

    const onClickHandler = () => {
      
        const el = document.getElementById("big-grapher");
        if (el)
          scrollIntoView(el, { scrollMode: "if-needed", behavior: "smooth" });

        onClickCallback({type: boxTitle, stats:newData, 'labelValue':boxLabelValue, 'percentageValue':boxPercentageValue});
        //console.log('stats debug', {type: title, stats:data, labelValue, percentageValue});
        //debugger;
    }

    const onClickSnapshot = async () => {
      onScreenshot({data: {type: boxTitle, stats:newData, 'labelValue':boxLabelValue, 'percentageValue':boxPercentageValue}, showScreenshotPopup: true});
    }

    const plotWidth = useBreakpointValue([120, 160, 220]);
   
    return (
            <>
            { returnStatBox && showBox &&
              
          <Stat 
                layerStyle={"bgBorderRoundedHoverShadow"}
                // width={['100%', 180, 180, 180]}
                w="full"
                // margin={mode == "stats" ? "" : "auto"}
                // mt={9}
                // mr={mode == "stats" ? ["27px",0,0,0] : ""}
                overflow="hidden"
                // _even={mode == "stats" ? {mr:[0,0,0,0]} : {}}
                // style={boxStyleOverwrite}
                onClick={ (isClickable) ? onClickHandler : undefined }
                cursor={ (isClickable) ? "pointer" : "initial" }
                _hover={ (isClickable)
                          ? 
                          {
                            background: darkModeClickableBg,
                            transition:'background 300ms',
                            borderRadius:'12px'
                          }
                          : 
                          {}
                        }
              p={3}
              >
                
                <StatLabel 
                  // fontSize={13}
                  fontWeight="600"
                  textTransform="uppercase"
                  textStyle={textStyle['h3.bold.standard']}
                  mb={0}
                  // color={darkModeHeadingColor}
                  letterSpacing="1.2px"
                  // style={labelStyleOverwrite}
                >
                  {title}
                  { canScreenshot &&
                    <Box position={"absolute"}  top={"6px"} right={"10px"}>
                      <IconButton
                        p={0}
                        m={0}
                        variant="outline"
                        size={"sm"}
                        border={0}
                        icon={<AiOutlineCamera/>}
                        onClick={() => {
                          onClickSnapshot();
                        }}
                        aria-label='Take Stat Screenshot'
                        color={darkModeSnapshotColor}
                        _hover={{
                          color: darkModeSnapshotColorHover
                        }}
                      />
                    </Box>
                  }
                </StatLabel>
                <StatNumber
                  // fontSize={30}
                  // fontWeight="600"
                  textStyle={textStyle['body.medium.light']}
                  mt={2}
                  // color={darkModeNumberColor}
                >
                  {numberWithCommas(labelValue)}
                </StatNumber>
                {
                  !disableComparison && (
                <Box
                  mt={2}
                      // fontSize={15}
                      fontWeight="600"
                      // textTransform="uppercase"
                      color={(findNumSign(boxPercentageValue)=="+")? color['secondary.lightMode.default'] :color['text.lightMode.inactive']}
                      // mb={3}
                    >
                      {findNumSign(boxPercentageValue)}{boxPercentageValue}%
                      <Box
                        as="span"
                        // fontWeight="200"
                    ml={1}
                    mt={2}
                        fontSize={12}
                        // color="#909090"
                        // textStyle={textStyle['body.medium.inactive']}
                        textStyle="body.medium.inactive"
                      >
                        vs. previous period
                      </Box>
                    </Box>
                  )
                }
                <StatHelpText p={0} m={0} mt={4}>
                  <XYPlot
                    stackBy="y"
                    width={plotWidth}
                    height={35}
                    margin={{left: 0, right: 0, top: 6, bottom: 6}}
                  >
                    <GradientDefs>
                      <linearGradient id="CoolGradient" x1="0" x2="0" y1="0" y2="1">
                        <stop offset="0%" stopColor="#11BB8D" stopOpacity={0.7}/>
                        <stop offset="100%" stopColor="#93eed5" stopOpacity={0.2} />
                      </linearGradient>
                    </GradientDefs>
                    <LineSeries
                      curve={'curveNatural'}
                      color="#11BB8D"
                      data={newData}
                    />
                    <AreaSeries
                      data={newData} 
                      opacity={1}
                      curve={'curveNatural'}
                      style={{
                      fill:"url(#CoolGradient)",
                      stroke:'#11BB8D',
                      strokeWidth:'0px'
                      }} 
                    />
                  </XYPlot>
                </StatHelpText>
              </Stat>
            }
            </>  
          );
}